import { welcomeDealEventSlug } from '@/constants/events/welcome-deal.const'
import { AdPetType } from '@/graphql/generated/schemas'
import { WelcomeDealSlugKeyType, welcomeDealSlugType } from '@/types/events-welcome-deal.type'

const sectionTopPosition = (offset: number, tabHeight?: number) => {
  const tabMenuHeight = tabHeight || 44
  return offset - tabMenuHeight
}

const isWelcomeDealEvent = (slug: string) => {
  return slug.includes(welcomeDealEventSlug)
}

const getWelcomeDealEventSlug = ({
  slug,
  pagePetType = AdPetType.Dog,
}: {
  slug: string
  pagePetType: WelcomeDealSlugKeyType
}) => {
  if (isWelcomeDealEvent(slug)) {
    return welcomeDealSlugType[pagePetType]
  }

  return null
}

export { sectionTopPosition, isWelcomeDealEvent, getWelcomeDealEventSlug }
